export const HPDisplayRules = {
    whitelist: {
        showFullTopNav: true,
		    showFullSidebar: true,
    },
    blacklist: {
        showFullTopNav: false,
        showFullSidebar: false,
    },
};



// WEBPACK FOOTER //
// ./src/app/config/app.displayRules.config.js